/**
 * AURORE — Cart Page JavaScript  (assets/aurore-cart.js)
 *
 * KEY FIX (this version):
 *  Shopify /cart/change.js rejects the full line-item key
 *  "49357464174868:8cdf7632e9ad924eb8c8b5432df6f320" with
 *  "no valid id or line parameter".
 *  The correct payload is { id: <variantId>, quantity: n } where
 *  variantId is the numeric part before the colon.
 *  We extract that with key.split(':')[0].
 *
 * Other fixes carried forward:
 *  - Subtotal = items_subtotal_price (pre cart-level discounts)
 *  - Total    = total_price (post all discounts)
 *  - Discount rows rebuilt dynamically after AJAX
 *  - Loading state cleared in both success and error paths (no .finally)
 *  - Raw response logged to console for future debugging
 */

(function () {
  'use strict';

  /* ══════════════════════════════════════════════════════════
     HELPERS
  ══════════════════════════════════════════════════════════ */

  function showToast(message, type, duration) {
    duration = duration || 3200;
    var toast = document.getElementById('aurToast');
    if (!toast) return;
    toast.textContent = message;
    toast.className = 'aur-toast show';
    if (type === 'error')        toast.style.background = '#C0392B';
    else if (type === 'success') toast.style.background = '#4A7C59';
    else                         toast.style.background = '';
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () {
      toast.classList.remove('show');
      toast.style.background = '';
    }, duration);
  }

  function formatMoney(cents) {
    var symbol = '$';
    if (window.Shopify && window.Shopify.currency) {
      var sym = { USD:'$', GBP:'£', EUR:'€', CAD:'CA$', AUD:'A$', INR:'₹', JPY:'¥' };
      symbol = sym[window.Shopify.currency.active] || '$';
    }
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return symbol + amount;
  }

  /* Safe .closest() polyfill */
  function closest(el, selector) {
    if (el.closest) return el.closest(selector);
    while (el && el.nodeType === 1) {
      if ((el.matches || el.msMatchesSelector).call(el, selector)) return el;
      el = el.parentNode;
    }
    return null;
  }

  /* ══════════════════════════════════════════════════════════
     CART API
     CRITICAL FIX: /cart/change.js needs the variant ID only.
     A line-item key looks like "49357464174868:8cdf7632e9ad..."
     Shopify rejects the full key — split on ':' and use [0].
  ══════════════════════════════════════════════════════════ */

  function cartChangeQty(lineItemKey, quantity) {
    if (window.AuroreCertificate) {
      return window.AuroreCertificate.changeQuantity(lineItemKey, quantity).then(function (cart) {
        window.location.reload();
        return cart;
      });
    }
    /* Extract numeric variant ID from key like "49357464174868:abc123" */
    var variantId = lineItemKey.split(':')[0];

    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(function (res) {
      var status = res.status;
      return res.text().then(function (text) {
        if (status < 200 || status >= 300) {
          var msg = 'HTTP ' + status;
          try { msg = JSON.parse(text).description || msg; } catch (e) {}
          throw new Error(msg);
        }
        try { return JSON.parse(text); }
        catch (e) { throw new Error('Bad JSON from /cart/change.js'); }
      });
    });
  }

  function cartUpdate(data) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(data)
    }).then(function (res) {
      return res.text().then(function (text) {
        if (res.status < 200 || res.status >= 300) {
          var msg = 'HTTP ' + res.status;
          try { msg = JSON.parse(text).description || msg; } catch (e) {}
          throw new Error(msg);
        }
        try { return JSON.parse(text); }
        catch (e) { throw new Error('Bad JSON from /cart/update.js'); }
      });
    });
  }

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) { return r.json(); });
  }

  /* ══════════════════════════════════════════════════════════
     DOM REFS
  ══════════════════════════════════════════════════════════ */
  var lineItemsContainer = document.getElementById('aurLineItems');
  var orderSummary       = document.getElementById('aurOrderSummary');

  /* ══════════════════════════════════════════════════════════
     UPDATE SUMMARY UI
  ══════════════════════════════════════════════════════════ */
  function updateSummaryUI(cart) {
    if (!orderSummary) return;

    /* Subtotal = sum of line items BEFORE cart-level discount codes */
    var subtotalEl = document.getElementById('aurSubtotal');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);

    /* Rebuild cart-level discount rows */
    var subtotalRow = subtotalEl ? closest(subtotalEl, '.aur-os-row') : null;
    if (subtotalRow) {
      var existing = orderSummary.querySelectorAll('.aur-os-row--discount');
      for (var d = 0; d < existing.length; d++) existing[d].parentNode.removeChild(existing[d]);
      var discounts = cart.cart_level_discount_applications || [];
      var anchor = subtotalRow;
      for (var di = 0; di < discounts.length; di++) {
        var dRow = document.createElement('div');
        dRow.className = 'aur-os-row aur-os-row--discount';
        dRow.innerHTML =
          '<span>' + discounts[di].title + '</span>' +
          '<span>−' + formatMoney(discounts[di].total_allocated_amount) + '</span>';
        anchor.parentNode.insertBefore(dRow, anchor.nextSibling);
        anchor = dRow;
      }
    }

    /* Total = after all discounts */
    var totalEl = document.getElementById('aurTotal');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    var checkoutTotal = document.getElementById('aurCheckoutTotal');
    if (checkoutTotal) checkoutTotal.textContent = formatMoney(cart.total_price);

    /* Savings banner */
    var savingsEl = orderSummary.querySelector('.aur-os-savings');
    if (savingsEl) {
      if (cart.total_discount > 0) {
        savingsEl.style.display = '';
        var savStrong = savingsEl.querySelector('strong');
        if (savStrong) savStrong.textContent = ' ' + formatMoney(cart.total_discount);
      } else {
        savingsEl.style.display = 'none';
      }
    }

    /* Free shipping progress */
    var FREE_THRESHOLD = 15000;
    var remaining = FREE_THRESHOLD - cart.total_price;
    var pct = Math.min(100, Math.round((cart.total_price / FREE_THRESHOLD) * 100));

    var fill = document.querySelector('.aur-csp-fill');
    if (fill) fill.style.width = pct + '%';

    var cspText = document.querySelector('.aur-csp-text');
    if (cspText) {
      if (remaining > 0) {
        cspText.innerHTML = 'Add <strong>' + formatMoney(remaining) +
          '</strong> more for <strong class="aur-gold">free shipping</strong>';
        cspText.classList.remove('aur-csp-unlocked');
      } else {
        cspText.innerHTML = '🎉 You\'ve unlocked <strong>free shipping!</strong>';
        cspText.classList.add('aur-csp-unlocked');
      }
    }

    var mobileTotal = document.querySelector('#aurMobileSummaryToggle strong');
    if (mobileTotal) mobileTotal.textContent = formatMoney(cart.total_price);

    var cartMeta = document.querySelector('.aur-cart-meta');
    if (cartMeta) {
      cartMeta.textContent = cart.item_count +
        ' ' + (cart.item_count === 1 ? 'item' : 'items') +
        ' · Estimated delivery in 3–5 business days';
    }

    var shippingEl = document.getElementById('aurShipping');
    if (shippingEl) {
      shippingEl.innerHTML = remaining <= 0
        ? '<span style="color:#4A7C59;font-weight:500">Free</span>'
        : 'Calculated at checkout';
    }

    var badges = document.querySelectorAll(
      '#cart-count, .cart-count, [data-cart-count], .header__cart-count, .site-nav__cart-count'
    );
    for (var bi = 0; bi < badges.length; bi++) badges[bi].textContent = cart.item_count;

    var bubble = document.querySelector('.shopify-section .cart-count-bubble span[aria-hidden="true"]');
    if (bubble) bubble.textContent = cart.item_count;
  }

  /* ══════════════════════════════════════════════════════════
     CHANGE QUANTITY
  ══════════════════════════════════════════════════════════ */
  function changeQuantity(key, newQty) {
    if (!lineItemsContainer) return;
    lineItemsContainer.classList.add('aur-loading');

    cartChangeQty(key, newQty)
      .then(function () { return getCart(); })
      .then(function (cart) {
        lineItemsContainer.classList.remove('aur-loading');
        updateSummaryUI(cart);

        if (newQty === 0) {
          var row = lineItemsContainer.querySelector('[data-key="' + key + '"]');
          if (row) {
            row.style.transition = 'opacity .25s';
            row.style.opacity = '0';
            setTimeout(function () {
              if (row.parentNode) row.parentNode.removeChild(row);
              if (cart.item_count === 0) window.location.reload();
            }, 280);
          }
          showToast('Item removed from your bag.', 'info');
        } else {
          var row2 = lineItemsContainer.querySelector('[data-key="' + key + '"]');
          if (row2) {
            var qtyInput = row2.querySelector('.aur-cli-qty-num');
            if (qtyInput) qtyInput.value = newQty;

            /* Match item by variant ID since key includes the hash */
            var variantId = parseInt(key.split(':')[0], 10);
            var cartItem = null;
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].variant_id === variantId) { cartItem = cart.items[i]; break; }
            }
            if (cartItem) {
              var priceEl = row2.querySelector('.aur-cli-price');
              if (priceEl) {
                if (cartItem.original_line_price !== cartItem.final_line_price) {
                  priceEl.innerHTML =
                    '<span class="aur-cli-price-compare">' +
                      formatMoney(cartItem.original_line_price) +
                    '</span><span class="aur-cli-price-sale">' +
                      formatMoney(cartItem.final_line_price) +
                    '</span>';
                } else {
                  priceEl.textContent = formatMoney(cartItem.final_line_price);
                }
              }
              var minusBtn = row2.querySelector('.aur-qty-minus');
              if (minusBtn) {
                minusBtn.disabled = newQty <= 1;
                minusBtn.style.opacity = newQty <= 1 ? '0.35' : '';
              }
            }
          }
        }
      })
      .catch(function (err) {
        lineItemsContainer.classList.remove('aur-loading');
        console.error('[Aurore Cart] FAILED:', err.message);
        showToast('Could not update cart. Please try again.', 'error');
        /* Revert qty input */
        getCart().then(function (cart) {
          var variantId = parseInt(key.split(':')[0], 10);
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].variant_id === variantId) {
              var inp = lineItemsContainer.querySelector('input[data-key="' + key + '"]');
              if (inp) inp.value = cart.items[i].quantity;
              break;
            }
          }
        });
      });
  }

  /* ══════════════════════════════════════════════════════════
     INIT: disable minus buttons at qty=1 on page load
  ══════════════════════════════════════════════════════════ */
  if (lineItemsContainer) {
    var initInputs = lineItemsContainer.querySelectorAll('.aur-cli-qty-num');
    for (var ii = 0; ii < initInputs.length; ii++) {
      if (parseInt(initInputs[ii].value, 10) <= 1) {
        var initRow = closest(initInputs[ii], '.aur-line-item');
        if (initRow) {
          var initMinus = initRow.querySelector('.aur-qty-minus');
          if (initMinus) { initMinus.disabled = true; initMinus.style.opacity = '0.35'; }
        }
      }
    }
  }

  /* ══════════════════════════════════════════════════════════
     EVENT DELEGATION — line items
  ══════════════════════════════════════════════════════════ */
  if (lineItemsContainer) {

    lineItemsContainer.addEventListener('click', function (e) {
      var minus  = closest(e.target, '.aur-qty-minus');
      var plus   = closest(e.target, '.aur-qty-plus');
      var remove = closest(e.target, '.aur-cli-remove');
      var save   = closest(e.target, '.aur-cli-save');

      if (minus) {
        var key = minus.getAttribute('data-key');
        var inp = lineItemsContainer.querySelector('input[data-key="' + key + '"]');
        if (!inp) return;
        var cur = parseInt(inp.value, 10) || 1;
        if (cur <= 1) {
          if (!confirm('Remove this item from your bag?')) return;
          changeQuantity(key, 0);
        } else {
          changeQuantity(key, cur - 1);
        }
        return;
      }

      if (plus) {
        var key2 = plus.getAttribute('data-key');
        var inp2 = lineItemsContainer.querySelector('input[data-key="' + key2 + '"]');
        if (!inp2) return;
        changeQuantity(key2, (parseInt(inp2.value, 10) || 0) + 1);
        return;
      }

      if (remove) {
        if (confirm('Remove this item from your bag?')) {
          changeQuantity(remove.getAttribute('data-key'), 0);
        }
        return;
      }

      if (save) {
        showToast('💛 Create an account to save items to your wishlist!', 'info', 4000);
        return;
      }
    });

    lineItemsContainer.addEventListener('change', function (e) {
      var inp = closest(e.target, '.aur-cli-qty-num');
      if (!inp) return;
      var newQty = Math.max(0, parseInt(inp.value, 10) || 0);
      inp.value = newQty;
      if (newQty === 0 && !confirm('Remove this item from your bag?')) {
        inp.value = 1;
        return;
      }
      changeQuantity(inp.getAttribute('data-key'), newQty);
    });

    lineItemsContainer.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && closest(e.target, '.aur-cli-qty-num')) {
        e.preventDefault();
        e.target.blur();
      }
    });
  }

  /* ══════════════════════════════════════════════════════════
     MOBILE SUMMARY TOGGLE
  ══════════════════════════════════════════════════════════ */
  var mobileSummaryToggle = document.getElementById('aurMobileSummaryToggle');
  if (mobileSummaryToggle && orderSummary) {
    mobileSummaryToggle.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      orderSummary.classList.toggle('visible', !expanded);
    });
  }

  /* ══════════════════════════════════════════════════════════
     GIFT MESSAGE
  ══════════════════════════════════════════════════════════ */
  var giftToggle   = document.getElementById('aurGiftToggle');
  var giftBox      = document.getElementById('aurGiftBox');
  var saveGiftBtn  = document.getElementById('aurSaveGift');
  var giftTextarea = giftBox ? giftBox.querySelector('.aur-gift-textarea') : null;

  if (giftToggle && giftBox) {
    giftToggle.addEventListener('click', function () {
      var open = giftBox.classList.toggle('open');
      giftToggle.setAttribute('aria-expanded', String(open));
    });
  }

  if (saveGiftBtn && giftTextarea) {
    saveGiftBtn.addEventListener('click', function () {
      var message = giftTextarea.value.trim();
      saveGiftBtn.textContent = 'Saving…';
      saveGiftBtn.disabled = true;
      cartUpdate({ attributes: { 'Gift Message': message } })
        .then(function () {
          showToast('🎁 Gift message saved!', 'success');
          saveGiftBtn.textContent = 'Saved ✓';
          setTimeout(function () {
            saveGiftBtn.textContent = 'Save Message';
            saveGiftBtn.disabled = false;
          }, 2500);
        })
        .catch(function () {
          showToast('Could not save message. Please try again.', 'error');
          saveGiftBtn.textContent = 'Save Message';
          saveGiftBtn.disabled = false;
        });
    });
  }

  /* ══════════════════════════════════════════════════════════
     PROMO CODE
  ══════════════════════════════════════════════════════════ */
  var promoApplyBtn = document.getElementById('aurPromoApply');
  var promoInput    = document.getElementById('aurPromoInput');
  var promoMsg      = document.querySelector('.aur-promo-msg');

  function showPromoMsg(text, type) {
    if (!promoMsg) return;
    promoMsg.textContent = text;
    promoMsg.className = 'aur-promo-msg show aur-promo-msg--' + (type || 'ok');
  }
  function hidePromoMsg() { if (promoMsg) promoMsg.className = 'aur-promo-msg'; }

  if (promoApplyBtn && promoInput) {
    promoApplyBtn.addEventListener('click', function () {
      var code = promoInput.value.trim();
      if (!code) { showPromoMsg('Please enter a promo code.', 'error'); promoInput.focus(); return; }
      hidePromoMsg();
      promoApplyBtn.textContent = 'Applying…';
      promoApplyBtn.disabled = true;
      showPromoMsg('Redirecting to checkout with code "' + code + '"…', 'ok');
      setTimeout(function () {
        window.location.href = '/checkout?discount=' + encodeURIComponent(code);
      }, 800);
    });
    promoInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); promoApplyBtn.click(); }
      else hidePromoMsg();
    });
    promoInput.addEventListener('input', hidePromoMsg);
  }

  /* ══════════════════════════════════════════════════════════
     RECOMMENDATIONS
  ══════════════════════════════════════════════════════════ */
  var recsSection = document.querySelector('.aur-recs[data-product-id]');
  if (recsSection) {
    var productId = recsSection.getAttribute('data-product-id');
    var recsGrid  = recsSection.querySelector('.aur-recs-grid');
    if (productId && recsGrid && recsGrid.children.length === 0) {
      fetch('/recommendations/products.json?product_id=' + productId + '&limit=4', {
        credentials: 'same-origin'
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.products || !data.products.length) { recsSection.style.display = 'none'; return; }
          data.products.forEach(function (p) {
            var card = document.createElement('a');
            card.href = '/products/' + p.handle;
            card.className = 'aur-rec-card';
            card.innerHTML =
              '<div class="aur-rec-img">' +
                (p.featured_image
                  ? '<img src="' + p.featured_image + '" alt="' + p.title + '" loading="lazy">'
                  : '<div class="aur-rec-img-placeholder"></div>') +
              '</div>' +
              '<div class="aur-rec-name">' + p.title + '</div>' +
              '<div class="aur-rec-material">' + (p.product_type || '') + '</div>' +
              '<div class="aur-rec-price">' + formatMoney(p.price) + '</div>';
            recsGrid.appendChild(card);
          });
        })
        .catch(function () { recsSection.style.display = 'none'; });
    }
  }

  /* ══════════════════════════════════════════════════════════
     KEYBOARD: Escape
  ══════════════════════════════════════════════════════════ */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (orderSummary && orderSummary.classList.contains('visible')) {
        orderSummary.classList.remove('visible');
        if (mobileSummaryToggle) mobileSummaryToggle.setAttribute('aria-expanded', 'false');
      }
      var toast = document.getElementById('aurToast');
      if (toast) toast.classList.remove('show');
    }
  });

})();
